import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { Row,Col,Card,Image,Placeholder } from 'react-bootstrap';
const FacultyDirectory = ({ pageData }) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Faculties,setFaculties]=useState([]);
    useEffect(()=>
    {
        const FacultyByTypeAndDepartment = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"faculty/byUserTypeAndDepartment/1/"+pageData.sp_sd_id);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.su_id + "/suPhoto")
                                .then(up => up.json());
                            const fetch2 = fetch(global.config.API_URL + "userDetails/byUserField/"+e.su_id+"/2")
                                .then(ud => ud.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([ups, uds]) => {
                                    return {
                                        ...e,
                                        ups,
                                        uds
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].suPhoto = (el.ups.length > 0) ? global.config.uploadPath + el.ups[0].up_fname + el.ups[0].up_ext : '';
                            result[i].suDesignation = (el.uds.length > 0) ? el.uds[0] : [];
                        });
                        setFaculties(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('FacultyByTypeAndDepartment File :', error);
                        setLoading(false);
                    });
                }
                else{
                    setFaculties([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('FacultyByTypeAndDepartment : Result',result); }
            } catch (error) 
            {
                console.error('FacultyByTypeAndDepartment : Error', error.message);
                setLoading(false);
            }
        };
        FacultyByTypeAndDepartment();
    },[pageData])
    return (
        <Card className='mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? "संकाय निर्देशिका" : "Faculty Directory"}
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <Row className='row-cols-1 row-cols-sm-2 row-cols-md-4 g-3'>
                    {[...Array(12)].map((_,index)=>(
                        <Col key={index}>
                            <Card className="text-center" style={{boxShadow:"8px 8px 0rem rgba(0, 0, 0, 0.15)"}} data-aos="flip-up" data-aos-duration="1000">
                                <Card.Body>
                                    <Placeholder xs={12} className="img-fluid rounded border mb-3" style={{minHeight:"150px"}} />
                                    <Card.Title><Placeholder xs={10} /></Card.Title>
                                    <Card.Text><Placeholder xs={10} bg="secondary" /></Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                    </Row>
                    ) : (
                    <Row className='row-cols-1 row-cols-sm-2 row-cols-md-4 g-3'>
                    {Faculties.map((su,index)=>(
                        <Col key={index}>
                            <Card className="text-center shadow-lg h-100" data-aos="flip-up" data-aos-duration="1000">
                                <Card.Body>
                                    <Image src={su.suPhoto} fluid className="rounded border mb-3" />
                                    <Card.Title>{appLanguage === 'hi' ? su.su_name_hi || su.su_name : su.su_name}</Card.Title>
                                    <Card.Text className='text-secondary'>
                                        {appLanguage === 'hi' ? su.suDesignation.ud_details_hi || su.suDesignation.ud_details : su.suDesignation.ud_details}
                                    </Card.Text>
                                    <NavLink to={appLanguage === 'hi' ? `/प्रोफ़ाइल/विवरण/${su.su_htaccess_hi || su.su_htaccess}` : `/profile/details/${su.su_htaccess}`} className="stretched-link" target='_blank' rel="noopener noreferrer">
                                        <span className='d-none'>Go Profile</span>
                                    </NavLink>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                    </Row>
                )}
            </Card.Body>
        </Card>
    );
}
export default FacultyDirectory;